"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VerificationCodeResetPassword = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _GradientPanel = require("../../atoms/GradientPanel");

var _CarouselImagesLogin = require("../../molecules/CarouselImagesLogin");

var _react = require("react");

var _LogoImage = require("../../atoms/LogoImage");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _GeneralInput = require("../../atoms/GeneralInput");

var _GeneralButton = require("../../atoms/GeneralButton");

var _utils = require("./utils");

var _jsxRuntime = require("react/jsx-runtime");

var VerificationCodeResetPassword = function VerificationCodeResetPassword(_ref) {
  var _ref$imageArrayCarous = _ref.imageArrayCarousel,
      imageArrayCarousel = _ref$imageArrayCarous === void 0 ? [] : _ref$imageArrayCarous,
      textCarousel = _ref.textCarousel,
      backogroundColorCarousel = _ref.backogroundColorCarousel;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      emptyVerificationCode = _useState2[0],
      setEmptyVerificationCode = _useState2[1];

  var _useState3 = (0, _react.useState)(),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      inputCodeVerificationAll = _useState4[0],
      setInputCodeVerificationAll = _useState4[1];

  var inputPositions = [1, 2, 3, 4, 5, 6];
  (0, _react.useEffect)(function () {
    setInputCodeVerificationAll(document.querySelectorAll("[id^='verificationCodeInput']"));
  }, []);
  var loginRight = [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoImage.LogoImage, {}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "credenciales",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.AvenirNext,
      color: _variables.GlobalColors.s5,
      text: "Ingresa tus credenciales"
    })
  }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "user",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      text: "Ingresa el código de verificación enviado a:",
      headerType: "input-name-header"
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "verification-code",
      children: inputPositions.map(function (position) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralInput.GeneralInput, {
          inputId: "verificationCodeInput".concat(position),
          inputType: "text",
          inputPlaceholder: "X",
          validateInput: _utils.validateInput,
          inputsArray: inputCodeVerificationAll,
          position: position,
          maxChar: 1
        });
      })
    }), emptyVerificationCode && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      children: "Ingrese su c\xF3digo de verificaci\xF3n"
    })]
  }, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "resend-code",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: "Reenviar c\xF3digo de verificaci\xF3n"
    })
  }, "4"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "button-center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general-default-button",
      label: "Enviar",
      onClick: function onClick(e) {
        return (0, _utils.validate)(inputCodeVerificationAll, setEmptyVerificationCode);
      }
    })
  }, "5"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "reset-password",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      children: "Regresar..."
    })
  }, "6")];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "home-retailer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CarouselImagesLogin.CarouselImagesLogin, {
        panelImg: imageArrayCarousel,
        panelText: textCarousel,
        panelColor: backogroundColorCarousel
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "home-login-retailer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradientPanel.GradientPanel, {
        componentsArray: loginRight,
        panelType: "home-login",
        panelColor: _variables.GlobalColors.white
      })
    })]
  });
};

exports.VerificationCodeResetPassword = VerificationCodeResetPassword;